import React from 'react'
import { Draggable } from 'react-beautiful-dnd'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import ListGroupUI from './ListGroupUI'
import RowLeftUI from './RowLeftUI'
import RowRightUI from './RowRightUI'
import './ListNode.css'

const ListNodeUI = ({context, messageList, index, project, task, currentTask, projectUserMap, onSetEditMode,
    onTaskClick, onUnfoldClick, onFoldClick, unfoldedTaskIdSet,
    onTaskNameCreateOrUpdate, moveMode
  }) =>
  <Draggable
    draggableId={task.taskId}
    index={index}
    isDragDisabled={task.editMode || !project.permissionList.includes('prj_participate')}
  >
    {provided => (
      <li className='list-node'
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        ref={provided.innerRef}
      >
        <LRTableRowUI
          context={context}
          className={`list-group-item ${currentTask && currentTask.taskId === task.taskId ? 'current' : ''}`}
          object={task}
          left={
            <RowLeftUI
              context={context}
              project={project}
              task={task}
              messageList={messageList}
              currentTask={currentTask}
              onSetEditMode={onSetEditMode}
              onUnfoldClick={onUnfoldClick}
              onFoldClick={onFoldClick}
              unfoldedTaskIdSet={unfoldedTaskIdSet}
              onTaskNameCreateOrUpdate={onTaskNameCreateOrUpdate}
            />
          }
          right={
            <RowRightUI
              context={context}
              task={task}
              moveMode={moveMode}
              projectUserMap={projectUserMap}
            />
          }
          onClick={onTaskClick}
          rowId={task.taskId}
        />
        <ListGroupUI
          context={context}
          project={project}
          messageList={messageList}
          taskList={unfoldedTaskIdSet.has(task.taskId) ? task.taskList : []}
          groupTaskId={task.taskId}
          currentTask={currentTask}
          projectUserMap={projectUserMap}
          onSetEditMode={onSetEditMode}
          onTaskClick={onTaskClick}
          onUnfoldClick={onUnfoldClick}
          onFoldClick={onFoldClick}
          unfoldedTaskIdSet={unfoldedTaskIdSet}
          onTaskNameCreateOrUpdate={onTaskNameCreateOrUpdate}
          moveMode={moveMode}
        />
      </li>
    )}
  </Draggable>

export default ListNodeUI
